import script from "./FacturaUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FacturaUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./FacturaUploadModal.vue?vue&type=style&index=0&id=2abcf550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2abcf550"]])

export default __exports__